export default {

  init() {

    $( document ).on( 'click', '.js-trigger-submit', this.triggerSubmit );

  },

  triggerSubmit( event ) {

    $( event.currentTarget ).parents( 'form' ).find( '.gform_footer .gform_button' ).trigger( 'click' );

  },

}



// WEBPACK FOOTER //
// ./scripts/modules/form.js